import React from 'react';
import { Sidebar } from '../../components/shared/Sidebar';
import { DashboardHeader } from '../../components/shared/DashboardHeader';
import { RentReliabilityScore } from '../../components/tenant/RentReliabilityScore';
import { ActivityTimeline } from '../../components/shared/ActivityTimeline';
import { MOCK_TENANT } from '../../utils/mockData';
import { motion } from 'framer-motion';
import { Download, Share2 } from 'lucide-react';
export function RentHistory() {
  return <div className="flex min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors pb-16 lg:pb-0" data-id="element-4924">
      <Sidebar data-id="element-4925" />

      <main className="flex-1 lg:ml-[240px] transition-all duration-300" data-id="element-4926">
        <DashboardHeader data-id="element-4927" />

        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 lg:py-8" data-id="element-4928">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-4929">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 lg:mb-8 gap-4" data-id="element-4930">
              <div className="min-w-0" data-id="element-4931">
                <h1 className="text-2xl font-bold text-gray-900 dark:text-white truncate" data-id="element-4932">
                  Rent History Report
                </h1>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 line-clamp-2" data-id="element-4933">
                  Your rental track record and reliability score.
                </p>
              </div>
              <div className="flex gap-3 flex-shrink-0" data-id="element-4934">
                <button className="inline-flex items-center px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg shadow-sm text-sm font-medium text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors whitespace-nowrap" data-id="element-4935">
                  <Share2 className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-4936" />
                  Share
                </button>
                <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 dark:bg-blue-700 dark:hover:bg-blue-800 transition-colors whitespace-nowrap" data-id="element-4937">
                  <Download className="h-4 w-4 mr-2 flex-shrink-0" data-id="element-4938" />
                  Download
                </button>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-4939">
              <div className="lg:col-span-2 space-y-6 lg:space-y-8" data-id="element-4940">
                {MOCK_TENANT.reliabilityScore && <RentReliabilityScore scoreData={MOCK_TENANT.reliabilityScore} data-id="element-4941" />}

                <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 sm:p-6 transition-colors" data-id="element-4942">
                  <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-6 truncate" data-id="element-4943">
                    Payment Timeline
                  </h3>
                  <ActivityTimeline data-id="element-4944" />
                </div>
              </div>

              <div className="space-y-6" data-id="element-4945">
                <div className="bg-blue-50 dark:bg-blue-900/20 rounded-xl p-6 border border-blue-100 dark:border-blue-800 transition-colors" data-id="element-4946">
                  <h3 className="text-sm font-bold text-blue-900 dark:text-blue-300 mb-2 truncate" data-id="element-4947">
                    Why this matters?
                  </h3>
                  <p className="text-sm text-blue-800 dark:text-blue-400 mb-4 break-words" data-id="element-4948">
                    A high Rent Reliability Score acts like a credit score for
                    housing. It helps you:
                  </p>
                  <ul className="list-disc list-inside text-sm text-blue-700 dark:text-blue-400 space-y-1" data-id="element-4949">
                    <li className="break-words" data-id="element-4950">Secure apartments faster</li>
                    <li className="break-words" data-id="element-4951">Negotiate better terms</li>
                    <li className="break-words" data-id="element-4952">
                      Avoid large upfront deposits
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </main>
    </div>;
}